import { useDispatch } from 'react-redux';
import { hideMessage, showMessage } from '~/actions';
import { CandidateStatus, ICandidateProfessionalEntity } from '~/domain/PermanentJobs';
import { useToggle } from '~/hooks';

interface IUseHireCandidate {
  candidate: ICandidateProfessionalEntity | undefined;
  hasCompletedInterview: boolean | undefined;
}

export const useHireCandidate = ({ candidate, hasCompletedInterview }: IUseHireCandidate) => {
  const dispatch = useDispatch();
  const [isOpen, controls] = useToggle();

  const canHire = candidate?.officeStatus === CandidateStatus.Interviewed;

  const handleHireClick = () => {
    if (!canHire) return;

    if (!hasCompletedInterview) {
      dispatch(
        showMessage({
          title: 'Please Complete an Interview First',
          message:
            "Hiring is available once at least one onsite interview has been scheduled and completed. This helps you evaluate their skills before making a decision. Go ahead and invite this professional to an available interview, or confirm them if they've already applied.",
          buttonText: 'Close',
          popupProps: {
            rightButtonAction: () => dispatch(hideMessage()),
          },
        }),
      );
      return;
    }

    controls.setOn();
  };

  return {
    canHire,
    controls,
    isOpen,
    handleHireClick,
  };
};
